package org.example.project.util

actual fun currentTimeMillis(): Double =
    kotlin.js.Date.now()
